<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title :title="title">
      <span slot="on-right">
        <el-button type="primary" v-if="addType!=='excel'" plain :class="$style['created-button']" @click="addType ='excel'">上传EXCEL模板创建
        </el-button>
        <el-button type="primary" v-if="addType!=='form'" plain :class="$style['created-button']" @click="goForm">手动填写样品
        </el-button>
        <el-button type="primary" v-if="this.billId && !recollect" plain :class="$style['created-button']" @click="chooseOrder">选择已有样品
        </el-button>
      </span>
    </pt-page-title>
    <pt-sub-title :subTitle="subTitle"></pt-sub-title>
    <base-table v-if="addType==='select'" :columns="tableLabels" :table-data="selectedData" selectType="">
      <template slot="operate" slot-scope="scope">
        <el-button type="text" @click="remove(scope.$index)">移除</el-button>
      </template>
    </base-table>

    <excel-form v-else-if="addType==='excel'" ref="excel"></excel-form>
    <sampleTableForm ref="sampleTable" v-model="form.orderList" v-else-if="addType==='form'" :recollect="recollect" :labExamItemList="labExamItemList" :hasExamList="hasExamList"></sampleTableForm>

    <!-- 选择样品 -->
    <select-lab-order-dialog v-if="addType==='select'" :onlyNoBill="true" orderStatusEnum="CREATED" :noExportOption="true" :dialogVisible="showDialog" @close="showDialog = false" @selectData="getSelectData" :pageSize="5" :selectedKeys="[]"></select-lab-order-dialog>
    <div class="button-div">
      <el-button type="primary" @click="saveOrder">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { tableLabels } from 'cps/lab-order/pt-gene-lab-order/lab-order-options'
import selectLabOrderDialog from 'cps/common/select-lab-order-dialog.vue'
import sampleTableForm from 'cps/trust-deed/pt-trust-deed-form/sample-table-form.vue'
import excelForm from './excel-form.vue'
// 组件class前缀
const prefixCls = 'pt-batch-add-lab-order'

export default {
	name: 'pt-batch-add-lab-order',
	props:{
		billDetail:{
			type:Object,
			default:function(){
				return {}
			}
		}
	},
  computed: {
    classes () {
      return `${prefixCls}`
    },
    title () {
      if (this.$route.query.billCode) {
        return `${this.recollect ? '重采' : '添加'}样品 委托单#${this.$route.query.billCode}`
      }
      return '添加样品'
    },
    billId () {
      return this.$route.query.billId
		},
		hasExamList(){
			return !!this.billId
		},
    recollect () {
      return this.$route.query.recollect === 'true'
    },
    subTitle () {
      let res = ''
      switch (this.addType) {
        case 'excel':
          res = '上次Excel添加样品'
          break
        case 'form':
          res = '手动填写添加样品'
          break
        case 'select':
          res = `已添加样品(${this.selectedData.length})`
          break
      }
      return res
    },
    getHasEnableOrders () {
      const orderList = this.form.orderList
      let disabledSampleTable = this.$refs.sampleTable.disabled
      return orderList?.length && disabledSampleTable
    },
  },
  components: {
    sampleTableForm,
    selectLabOrderDialog,
    excelForm
  },
  data () {
    return {
      tableLabels,
      showDialog: false,
      addType: 'excel',
      selectedData: [],
      loading: false,
      form: {
        orderList: [{ disabled: false }]
			},
			labExamItemList:[]
    }
	},
	watch:{
		billDetail:{
			handler:function(val){
				this.labExamItemList=val.labExamItemList
			},
			immediate:true
		}
	},
  methods: {
    goForm () {
      if (!this.billId) {
        this.$router.push('/lab-order-form/false/0')
      } else {
        this.addType = 'form'
      }
    },
    chooseOrder () {
      this.addType = 'select'
      this.showDialog = true
    },
    getSelectData (val) {
      console.log('===val', val)
      this.selectedData = val
      this.showDialog = false
    },
    cancel () {
      history.go(-1)
    },
    remove (index) {
      this.$confirm('确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectedData.splice(index, 1)
      })
    },
    addExistOrder () {
      if (!this.selectedData?.length) {
        this.$message.warning('请先选择样品')
        return
      }
      this.loading = true
      let data = {
        billId: this.billId,
        orderIds: this.selectedData.map(e => e.id)
      }
      this.$store.dispatch('addExistOrderToBill', data).then(res => {
        this.$message.success('操作成功')
        this.$router.push(`/trust-deed-detail/${this.billId}`)
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(() => {
        this.loading = false
      })
    },
    addNewOrders () {
      const orderList = this.form.orderList
      if (!this.getHasEnableOrders) {
        this.$message.warning('请先添加样品并保存')
        return
      }
      this.loading = true
      let data = {
        billId: this.billId,
        orderList
      }
      this.$store.dispatch('addNewOrdersToBill', data).then(res => {
        this.$message.success('操作成功')
        this.$router.push(`/trust-deed-detail/${this.billId}`)
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(() => {
        this.loading = false
      })
    },
    saveOrder () {
			// 有委托单id的情况下，执行完创建之后，返回到委托单详情
			console.log('this.addType==',this.addType, this.recollect)
      switch (this.addType) {
        case 'select':
          this.addExistOrder()
          break
        case 'form':
          this.recollect ? this.recollectOrders() : this.addNewOrders()
          break
        case 'excel':
					if(this.$refs.excel.excel&&this.$refs.excel.excel.length){
          this.$refs.excel.submit()
					}else{
						this.$message.error('请上传excel')
					}
          break
      }
    },
    recollectOrders(){
      const orderList = this.form.orderList
      if (!this.getHasEnableOrders) {
        this.$message.warning('请先添加样品并保存')
        return
      }
      this.loading = true
      let data = {
        workflow:'LAB_ORDER_RECOLLECT',
        orderList
      }
      this.$store.dispatch('recollectOrdersByBill', data).then(res => {
        this.$message.success('操作成功')
        this.$router.push(`/trust-deed-detail/${this.billId}`)
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(() => {
        this.loading = false
      })
    },
    getDetail(){
      this.loading = true
      this.$store.dispatch('getRecollectOrders', {billId:this.billId}).then((data) => {
        this.loading = false
        console.log('===d',data)
        this.form.orderList = data.map(e=>{
          return {
            ...e,
            disabled:false
          }
        })
      }).catch((error) => {
        this.loading = false
        this.$message.error(error || '获取样品信息失败！')
      })
    }
  },
  created(){
    if(this.recollect){
      this.getDetail()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
